export default /* css */ `
  :host {
    [class*='BookmakerClickOutContainer'] {
      cursor: unset;
    }

    [class*='OddsCellBtn']:hover:after {
      display: none;
    }
    
    @media (max-width:767px) {
      [class*='bestOddsStyles'] {
        width: 0;
      }    
    
      [class*='bestOddsStyles'] > svg {
        display: none;
      }
    }
  }

  [data-testid=odds-grid][data-enforce-mobile] {
    [class*='bestOddsStyles'] {
      width: 0;
    }    
  
    [class*='bestOddsStyles'] > svg {
      display: none;
    }
  }

  footer {
    background: var(--ogm-grid-main-bg-color);
    border: 1px solid var(--ogm-grid-main-border-color);
    border-radius: 5px;
    color: var(--ogm-text-body);
    padding: 12px 30px 11px 20px;
  }

  slot[name="footer-notice"],
  slot[name="footer-notice"] > a,
  .footer__icons > div
  {
    font-family: var(--oc-font-family);
    font-size: 10px;
  }

  .footer__icons {
    display: flex;
    justify-content: space-between;
    margin-top: 16px;
  }

  .footer__icons > div {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px;
  }

  .footer__icons img {
    height: 16px;
  }
`;
